import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import FormGenerator from "../../../../../../Components/FormGenerator";
import {
  SetOrganisationActivity,
  UpdateOrganisationActivityError,
} from "./OrganisationActivityActions";
import {
  Grid,
  Divider,
  makeStyles,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import UploadFilesComponent from "../../../../../../Components/FormGenerator/upload_files_component";
import AlertDialog from "../../../../../../Components/CustomDialog";

// const theme = createMuiTheme({
//   overrides: {
//     MuiFormControl: {
//       root: {
//         width: "100%",
//       },
//     },
//   },
// });

export default function Activity(props) {
  const dispatch = useDispatch();

  const {
    acuity_objective,
    internal_notes,
    review_date,
    current_area_being_reviewed,
    outcome_of_review_meeting_notes,
    meeting_date,
    history,
    next_meeting_date,
    action_required,
    who,
    priority_id,
    review,
    review_frequency_id,
    review_dates,
    next_review_agenda,
    review_reports,
    mi_required,
    meeting_details,
    client_action_lists,
    forms,
  } = useSelector((state) => state.organisationActivityReducer.data);

  const errors = useSelector(
    (state) => state.organisationActivityReducer.errors
  );
  const reviewFrequencySelector = useSelector(
    (state) => state.commonReducer.organisationDropdowns.review_frequency
  );
  const userRole = useSelector((state) => state.commonReducer.role);
  const reviewReportSelector = useSelector(
    (state) => state.commonReducer.organisationDropdowns.review_reports
  );
  const formsSelector = useSelector(
    (state) => state.commonReducer.organisationDropdowns.forms
  );

  const reducerData = useSelector(
    (state) => state.organisationActivityReducer.data
  );

  const {
    priorities,
    who_by,
    org_areas,
    status,
    platforms,
    // forms: form
  } = useSelector((state) => state.commonReducer.organisationDropdowns);

  const handleInputChange = (value, index, type, key) => {
    props.setSomeChangeDetected(true);
    if (!formInput.find((item) => item.name === "priority_id")) {
      formInput.push({
        name: "priority_id",
        value: priority_id,
      });
    }
    const updatedForm = formInput;
    let keyIndex = index;
    if (key && !type) {
      keyIndex = formInput.findIndex((item) => item.name === key);
      if (keyIndex === -1) {
        updatedForm.push({
          name: key,
          value: value,
        });
      } else {
        updatedForm[keyIndex]["value"] = value;
      }
    } else if (!type) {
      updatedForm[index]["value"] = value;
    } else {
      updatedForm[index][type] = value;
    }
    setFormInput(updatedForm);
    const formData = {};
    formInput.forEach((item, fIndex) => {
      if (fIndex === keyIndex) {
        formData[item.name] = item.value ?? "";
        dispatch(SetOrganisationActivity(formData));
      }
    });
    dispatch(UpdateOrganisationActivityError(updatedForm[index].name));
  };

  const OnlyAcuityArray = ["review", "next_review_agenda"];

  const formArray = [
    {
      componentType: "input",
      type: "text",
      label: "Acuity objective for this organisation",
      name: "acuity_objective",
      multiline: true,
      placeholder: "Acuity objective for this organisation",
      handleChange: handleInputChange,
      value: acuity_objective,
    },
    {
      componentType: "input",
      type: "text",
      multiline: true,
      label: "Reporting and review internal notes",
      name: "internal_notes",
      placeholder: "Internal notes",
      handleChange: handleInputChange,
      value: internal_notes,
    },
    // {
    //   componentType: "datePicker",
    //   type: "text",
    //   label: "Completed FollowUp Date",
    //   name: "completed_follow_up_date",
    //   plusIcon: 'yes',
    //   getAllValue: true,
    // },
    {
      componentType: "input",
      type: "text",
      label: "Current area being reviewed",
      name: "current_area_being_reviewed",
      placeholder: "Current area being reviewed",
      handleChange: handleInputChange,
      value: current_area_being_reviewed,
    },
    {
      componentType: "select",
      label: "MI required",
      name: "mi_required",
      value: mi_required,
      placeholder: "MI required",
      selectOptions: [
        { id: "Yes", value: "Yes", name: "Yes" },
        { id: "No", value: "No", name: "No" },
      ],
      handleChange: handleInputChange,
    },
    {
      componentType: "multiSelectChip",
      label: "Reports",
      name: "forms",
      value: forms,
      placeholder: "Select reports",
      // selectOptions: formsSelector,
      itemArr: formsSelector,
      handleChange: handleInputChange,
      dropDown: "Form",
      field_name: "name",
    },
    {
      componentType: "select",
      // label: "Review yes/no",
      label: "Review required",
      name: "review",
      value: review,
      placeholder: "Review yes/no",
      selectOptions: [
        { id: "Yes", value: "Yes", name: "Yes" },
        { id: "No", value: "No", name: "No" },
      ],
      handleChange: handleInputChange,
    },
    {
      componentType: "multiSelectChip",
      label: "Review reports required",
      name: "review_reports",
      value: review_reports,
      placeholder: "Review reports required",
      id: "review_reports",
      selectOptions: review_reports,
      itemArr: reviewReportSelector,
      handleChange: handleInputChange,
      dropDown: "ReviewReport",
      field_name: "name",
    },
    {
      componentType: "SelectSpecific",
      label: "Review frequency",
      name: "review_frequency_id",
      id: "review_frequency_id",
      value: review_frequency_id,
      placeholder: "Review frequency",
      selectOptions: reviewFrequencySelector,
      // selectOptions: [{id: 1, value: '1', name: '1'},{id: 2, value: '2', name: '2'},{id: 3, value: '3', name: '3'},{id: 4, value: '4', name: '4'}],
      handleChange: handleInputChange,
      dropDown: "ReviewFrequency",
      field_name: "name",
      addOptionText: "Other",
    },
    {
      componentType: "datePicker",
      required: true,
      label: "Review dates*",
      name: "review_dates",
      value: review_dates,
      plusIcon: "yes",
      getAllValue: true,
      placeholder: "DD/MM/YYYY",
      helperText: errors.review_dates && "Please select a date",
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      type: "text",
      multiline: true,
      label: "Next review agenda",
      name: "next_review_agenda",
      placeholder: "Next review agenda",
      handleChange: handleInputChange,
      value: next_review_agenda || "",
    },
    {
      label: "Meeting/Call documents",
      componentType: "uploadFiles",
      name: "meeting_documents",
      buttonLabel: "Document upload",
      handleChange: handleInputChange,
      labelStyle: {},
    },
    {
      componentType: "rederComponent",
      name: "meeting_details",
      value: meeting_details,
      component: (
        <MeetingDetailsComponent
          handleChange={handleInputChange}
          name="meeting_details"
          value={meeting_details}
          label="Meeting/Call dates"
          componentObject={[
            {
              componentType: "datePicker",
              type: "text",
              label: "Meeting date and time",
              name: "meeting_datetime",
            },
            {
              componentType: "timeComponent",
              type: "text",
              label: "Meeting start time",
              name: "start_time",
            },
            {
              componentType: "timeComponent",
              type: "text",
              label: "Meeting end time",
              name: "end_time",
            },
            {
              componentType: "input",
              type: "text",
              label: "Description of call",
              name: "description",
              placeholder: "Description of call",
              multiline: true,
            },
            {
              componentType: "input",
              type: "text",
              label: "Who involved in meeting",
              name: "who_involved",
              placeholder: "Who involved in meeting",
              multiline: true,
            },
            {
              componentType: "input",
              type: "text",
              label: "Prep required",
              name: "prep_required",
              placeholder: "Prep required",
              multiline: true,
            },
            {
              componentType: "input",
              type: "text",
              label: "Temporary owner",
              name: "temporary_owner",
              placeholder: "Temporary owner",
              multiline: true,
            },
            {
              componentType: "select",
              label: "Platform",
              name: "platform",
              placeholder: "Platform",
              selectOptions: platforms,
              handleChange: handleInputChange,
            },
            {
              componentType: "input",
              type: "text",
              label: "Briefing",
              name: "briefing",
              placeholder: "Briefing",
              multiline: true,
            },
          ]}
        />
      ),
    },
    {
      componentType: "rederComponent",
      name: "client_action_lists",
      value: client_action_lists,
      component: (
        <ClientActionListComponent
          handleChange={handleInputChange}
          name="client_action_lists"
          value={client_action_lists}
          label="Client action list"
          componentObject={[
            {
              componentType: "datePicker",
              type: "text",
              label: "Date received",
              name: "date_received",
            },
            {
              componentType: "select",
              label: "Priority",
              name: "priority_id",
              placeholder: "Priority",
              selectOptions: priorities,
              handleChange: handleInputChange,
            },
            {
              componentType: "select",
              label: "Status",
              name: "status",
              placeholder: "Status",
              selectOptions: status,
              handleChange: handleInputChange,
            },
            {
              componentType: "SelectSpecific",
              label: "Area",
              name: "org_area_id",
              id: "org_area_id",
              placeholder: "Area",
              selectOptions: org_areas,
              handleChange: handleInputChange,
              dropDown: "OrgArea",
              field_name: "name",
              isChild: true,
            },
            {
              componentType: "input",
              type: "text",
              label: "Description",
              name: "description",
              placeholder: "Description",
              multiline: true,
            },
            {
              componentType: "input",
              type: "text",
              label: "Stakeholder/s",
              name: "stakeholders",
              placeholder: "Stakeholders",
              multiline: true,
            },
            {
              componentType: "multiSelectChip",
              label: "Who by",
              name: "who_by",
              id: "who_by",
              placeholder: "who by",
              itemArr: who_by,
              isChild: true,
            },
            {
              componentType: "datePicker",
              type: "text",
              label: "Deadline date",
              name: "deadline_date",
            },
            {
              componentType: "datePicker",
              type: "text",
              label: "Completed date",
              name: "completed_date",
            },
          ]}
        />
      ),
    },
  ];

  const newArray =
    userRole !== "admin"
      ? formArray.filter((array) => OnlyAcuityArray.includes(array.name))
      : formArray;

  const [formInput, setFormInput] = useState(newArray);

  useEffect(() => {
    setFormInput(newArray);
  }, [errors, priorities]);

  return (
    <FormGenerator
      children={formInput}
      handleNext={props.handleNext}
      nextIndex={6}
      setId={props.setId}
      moduleName="organization"
    />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      display: "flex",
    },
  },
  gridRoot: {
    flexGrow: 1,
    marginBottom: "20px",
  },
  helperText: {
    color: "red",
  },
  disabled: {
    background: "#f5f2f2",
  },

  textInput: {
    "& input::placeholder": {
      color: "#808080",
      opacity: 1,
    },
  },
  meetingItems: {
    display: "flex",
    alignItems: "baseline",
    paddingBottom: "10px",
  },
  accordionWrapper: {
    flexGrow: 1,
    border: "1px solid #ccc",
    borderBottom: "0",
    "& > div": {
      minHeight: "0px !important",
    },
    "& > div > div:first-child": {
      minHeight: "0px !important",
      margin: 0,
    },
  },
  accordionTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
}));

const MeetingDetailsComponent = (props) => {
  const classes = useStyles();
  const { name, handleChange, label } = props;
  const [callMeetingItem, setCallMeetingItem] = useState([]);
  const [dialogState, setDialogState] = useState(undefined);
  const [dialogStateActionsMeeting, setDialogStateActionsMeeting] =
    useState(undefined);
  const [formInput, setFormInput] = useState(props?.componentObject);
  const { meeting_details } = useSelector(
    (state) => state.organisationActivityReducer.data
  );

  const handleInputChange = useCallback(
    (value, index, type, perentIndex) => {
      setCallMeetingItem((prevState) => {
        const keyIndex = [
          "meeting_datetime",
          "start_time",
          "end_time",
          "description",
          "who_involved",
          "prep_required",
          "temporary_owner",
          "platform",
          "briefing",
        ];
        prevState[perentIndex] = { ...prevState[perentIndex] };
        prevState[perentIndex][keyIndex[index]] = value;
        return [...prevState];
      });
      callMeetingItem?.length && handleChange(callMeetingItem, 0, "", name);
    },
    [callMeetingItem]
  );

  useEffect(() => {
    meeting_details?.length && setCallMeetingItem(meeting_details);
  }, [meeting_details]);

  useEffect(() => {
    props?.componentObject?.length &&
      setFormInput((oldValue) => [
        ...oldValue.map((item, index) => ({
          ...item,
          handleChange: handleInputChange,
          formGeneratorPerentIndex: index,
        })),
      ]);
  }, [props?.componentObject?.length]);

  const handleMeeting = (isAdd, index) => {
    if (isAdd) {
      const newCall = {
        meeting_datetime: "",
        start_time: "",
        end_time: "",
        description: "",
        who_involved: "",
        prep_required: "",
        temporary_owner: "",
        platform: [],
        briefing: "",
        expanded: true,
      };
      const newItem = [
        ...callMeetingItem.map((item) => ({ ...item, expanded: false })),
        ...[newCall],
      ];
      setCallMeetingItem(newItem);
      handleChange(newItem, 0, "", name);
    } else {
      callMeetingItem.splice(index, 1);
      callMeetingItem.map((item) => ({ ...item, expanded: false }));
      handleChange(callMeetingItem, 0, "", name);
      setCallMeetingItem([...callMeetingItem]);
    }
  };

  const handleChild = (isAdd, index, parentIndex) => {
    if (isAdd) {
      const newCall = {
        deadline_date: "",
        description: "",
        who: "",
        completed: false,
      };
      let updatedData = { ...callMeetingItem[parentIndex] };
      if (updatedData["detail_of_actions"]?.length) {
        updatedData["detail_of_actions"] = [
          ...updatedData["detail_of_actions"],
          ...[newCall],
        ];
      } else {
        updatedData["detail_of_actions"] = [newCall];
      }
      callMeetingItem[parentIndex] = { ...updatedData };
      setCallMeetingItem(callMeetingItem);
      handleChange(callMeetingItem, parentIndex, "", name);
    } else {
      callMeetingItem[parentIndex]["detail_of_actions"].splice(index, 1);
      handleChange(callMeetingItem, 0, "", name);
      setCallMeetingItem([...callMeetingItem]);
    }
  };

  const handleChildInputChange = useCallback(
    (value, index, type, parentIndex) => {
      const ParentIndexIds = parentIndex.split("-");
      setCallMeetingItem((prevState) => {
        const keyIndex = ["deadline_date", "description", "who", "completed"];
        const meetingItem = { ...prevState[ParentIndexIds[0]] };
        meetingItem["detail_of_actions"][ParentIndexIds[1]][keyIndex[index]] =
          value;
        prevState[ParentIndexIds[0]] = { ...meetingItem };
        return [...prevState];
      });
      callMeetingItem?.length &&
        handleChange(callMeetingItem, ParentIndexIds[0], "", name);
    },
    [callMeetingItem]
  );

  const formArray = [
    {
      componentType: "datePicker",
      type: "text",
      label: "Deadline date",
      name: "deadline_date",
      handleChange: handleChildInputChange,
    },
    {
      componentType: "input",
      type: "text",
      label: "Description",
      name: "description",
      placeholder: "Description",
      multiline: true,
      handleChange: handleChildInputChange,
    },
    {
      componentType: "input",
      type: "text",
      label: "Who",
      name: "who",
      placeholder: "Who",
      multiline: true,
      handleChange: handleChildInputChange,
    },
    {
      componentType: "singleCheckbox",
      label: "Completed",
      value: false,
      name: "completed",
      onChange: handleChildInputChange,
    },
  ];

  useEffect(() => {
    formArray?.length &&
      setFormInput((oldValue) => [
        ...oldValue.map((item, index) => ({
          ...item,
          handleChange: handleChildInputChange,
          formGeneratorPerentIndex: index,
        })),
      ]);
  }, [formArray?.length]);

  const handleCollapse = (index) => {
    setCallMeetingItem((oldValue) => [
      ...oldValue.map((item, itemIndex) => {
        if (itemIndex === index)
          return { ...item, expanded: item?.expanded ? !item.expanded : true };
        else return { ...item, expanded: false };
      }),
    ]);
  };

  return (
    <Grid container className={classes.gridRoot}>
      <Grid item xs={12} md={4}>
        {label}
      </Grid>
      <Grid item xs={12} md={7}>
        {callMeetingItem?.map((item, index) => {
          const formInputFields =
            props?.componentObject?.length &&
            props?.componentObject.map((fieldItem) => ({
              ...fieldItem,
              handleChange: handleInputChange,
              value: item[fieldItem.name],
            }));
          return (
            <div className={classes.meetingItems}>
              <Accordion
                className={classes.accordionWrapper}
                expanded={item?.expanded}
                onChange={(e) => {
                  handleCollapse(index);
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.accordionTitle}>
                    {label} #{index + 1}
                    <AddCircleIcon
                      type="submit"
                      onClick={(e) => {
                        e.stopPropagation();
                        setDialogState({
                          isOpen: true,
                          index,
                        });
                      }}
                      fontSize="large"
                      color="error"
                      style={{ cursor: "pointer", transform: "rotate(45deg)" }}
                    />
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid item xs={12}>
                    <FormGenerator
                      pIndex={index}
                      children={formInputFields}
                      handleNext={props.handleNext}
                      nextIndex={6}
                      setId={props.setId}
                      style={
                        {
                          // width: "100%",
                        }
                      }
                      moduleName="organization"
                    />
                    <Grid container>
                      <Grid item xs={12} md={4}>
                        Detail of action
                      </Grid>
                      <Grid item xs={12} md={8}>
                        {item?.detail_of_actions?.length
                          ? item?.detail_of_actions?.map(
                              (childItem, childIndex) => {
                                const formInputFields =
                                  formArray?.length &&
                                  formArray.map((fieldItem) => ({
                                    ...fieldItem,
                                    handleChange: handleChildInputChange,
                                    value: childItem[fieldItem.name],
                                  }));
                                return (
                                  <>
                                    <Grid container>
                                      <Grid item xs={11}>
                                        <FormGenerator
                                          pIndex={`${index}-${childIndex}`}
                                          children={formInputFields}
                                          handleNext={props.handleNext}
                                          nextIndex={6}
                                          setId={props.setId}
                                          style={
                                            {
                                              // width: "100%",
                                            }
                                          }
                                        />
                                      </Grid>
                                      <Grid item xs={1}>
                                        <AddCircleIcon
                                          type="submit"
                                          onClick={() =>
                                            setDialogStateActionsMeeting({
                                              isOpen: true,
                                              index,
                                              childIndex,
                                            })
                                          }
                                          fontSize="large"
                                          color="error"
                                          style={{
                                            cursor: "pointer",
                                            transform: "rotate(45deg)",
                                          }}
                                        />
                                      </Grid>
                                    </Grid>
                                    <Divider style={{ marginBottom: "20px" }} />
                                  </>
                                );
                              }
                            )
                          : null}
                        <AddCircleIcon
                          type="submit"
                          onClick={() => handleChild(true, 0, index)}
                          fontSize="large"
                          color="primary"
                          style={{ cursor: "pointer" }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </div>
          );
        })}

        <AddCircleIcon
          type="submit"
          onClick={() => handleMeeting(true, 0)}
          fontSize="large"
          color="primary"
          style={{ cursor: "pointer" }}
        />
      </Grid>
      {dialogState?.isOpen && (
        <AlertDialog
          dialogState={dialogState}
          dialogContent={`Are you sure you want to delete this meeting details?`}
          handleSubmit={(value) => handleMeeting(false, value?.index)}
          handleClose={() => setDialogState(undefined)}
        />
      )}
      {dialogStateActionsMeeting?.isOpen && (
        <AlertDialog
          dialogState={dialogStateActionsMeeting}
          dialogContent={`Are you sure you want to delete this detail of action?`}
          handleSubmit={(value) =>
            handleChild(false, value?.childIndex, value?.index)
          }
          handleClose={() => setDialogStateActionsMeeting(undefined)}
        />
      )}
    </Grid>
  );
};

const ClientActionListComponent = (props) => {
  const classes = useStyles();
  const { name, handleChange, label } = props;
  const [clientActionItem, setClientActionItem] = useState([]);
  const [dialogState, setDialogState] = useState(undefined);
  const [dialogStateActions, setDialogStateActions] = useState(undefined);
  const [formInput, setFormInput] = useState(props?.componentObject);
  const { client_action_lists } = useSelector(
    (state) => state.organisationActivityReducer.data
  );

  const handleInputChange = useCallback(
    (value, index, type, perentIndex) => {
      setClientActionItem((prevState) => {
        const keyIndex = [
          "date_received",
          "priority_id",
          "status",
          "org_area_id",
          "description",
          "stakeholders",
          "who_by",
          "deadline_date",
          "completed_date",
          "follow_up_date",
          "completed_follow_up_date",
        ];
        prevState[perentIndex] = { ...prevState[perentIndex] };
        prevState[perentIndex][keyIndex[index]] = value;
        return [...prevState];
      });
      clientActionItem?.length && handleChange(clientActionItem, 0, "", name);
    },
    [clientActionItem]
  );

  useEffect(() => {
    client_action_lists?.length && setClientActionItem(client_action_lists);
  }, [client_action_lists]);

  useEffect(() => {
    props?.componentObject?.length &&
      setFormInput((oldValue) => [
        ...oldValue.map((item, index) => ({
          ...item,
          handleChange: handleInputChange,
          formGeneratorPerentIndex: index,
        })),
      ]);
  }, [props?.componentObject?.length]);

  const handleClientAction = (isAdd, index) => {
    if (isAdd) {
      const newCall = {
        date_received: "",
        priority_id: "",
        status: "",
        org_area_id: 0,
        description: "",
        stakeholders: "",
        who_by: [],
        deadline_date: "",
        completed_date: "",
        expanded: true,
      };
      const newItem = [
        ...clientActionItem.map((item) => ({ ...item, expanded: false })),
        ...[newCall],
      ];
      setClientActionItem(newItem);
      handleChange(newItem, 0, "", name);
    } else {
      clientActionItem.splice(index, 1);
      clientActionItem.map((item) => ({ ...item, expanded: false }));
      handleChange(clientActionItem, 0, "", name);
      setClientActionItem([...clientActionItem]);
    }
  };

  const handleChild = (isAdd, index, parentIndex) => {
    if (isAdd) {
      const newCall = {
        follow_up_date: "",
        completed_follow_up_date: "",
      };
      let updatedData = { ...clientActionItem[parentIndex] };
      if (updatedData["follow_up_schedule"]?.length) {
        updatedData["follow_up_schedule"] = [
          ...updatedData["follow_up_schedule"],
          ...[newCall],
        ];
      } else {
        updatedData["follow_up_schedule"] = [newCall];
      }
      clientActionItem[parentIndex] = { ...updatedData };
      setClientActionItem(clientActionItem);
      handleChange(clientActionItem, parentIndex, "", name);
    } else {
      clientActionItem[parentIndex]["follow_up_schedule"].splice(index, 1);
      handleChange(clientActionItem, 0, "", name);
      setClientActionItem([...clientActionItem]);
    }
  };

  const handleChildInputChange = useCallback(
    (value, index, type, parentIndex) => {
      const ParentIndexIds = parentIndex.split("-");
      setClientActionItem((prevState) => {
        const keyIndex = ["follow_up_date", "completed_follow_up_date"];
        const meetingItem = { ...prevState[ParentIndexIds[0]] };
        meetingItem["follow_up_schedule"][ParentIndexIds[1]][keyIndex[index]] =
          value;
        prevState[ParentIndexIds[0]] = { ...meetingItem };
        return [...prevState];
      });
      clientActionItem?.length &&
        handleChange(clientActionItem, ParentIndexIds[0], "", name);
    },
    [clientActionItem]
  );

  const formArray = [
    {
      componentType: "datePicker",
      type: "text",
      label: "Follow up date",
      name: "follow_up_date",
      handleChange: handleChildInputChange,
    },
    {
      componentType: "datePicker",
      type: "text",
      label: "Completed follow up date",
      name: "completed_follow_up_date",
      handleChange: handleChildInputChange,
    },
  ];

  useEffect(() => {
    formArray?.length &&
      setFormInput((oldValue) => [
        ...oldValue.map((item, index) => ({
          ...item,
          handleChange: handleChildInputChange,
          formGeneratorPerentIndex: index,
        })),
      ]);
  }, [formArray?.length]);

  const handleCollapse = (index) => {
    setClientActionItem((oldValue) => [
      ...oldValue.map((item, itemIndex) => {
        if (itemIndex === index)
          return { ...item, expanded: item?.expanded ? !item.expanded : true };
        else return { ...item, expanded: false };
      }),
    ]);
  };

  return (
    <Grid container className={classes.gridRoot}>
      <Grid item xs={12} md={4}>
        {label}
      </Grid>
      <Grid item xs={12} md={7}>
        {clientActionItem?.map((item, index) => {
          const formInputFields =
            props?.componentObject?.length &&
            props?.componentObject.map((fieldItem) => ({
              ...fieldItem,
              handleChange: handleInputChange,
              value: item[fieldItem.name],
            }));
          return (
            <div className={classes.meetingItems}>
              <Accordion
                className={classes.accordionWrapper}
                expanded={item?.expanded}
                onChange={(e) => {
                  handleCollapse(index);
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.accordionTitle}>
                    {label} #{index + 1}
                    <AddCircleIcon
                      type="submit"
                      onClick={(e) => {
                        e.stopPropagation();
                        setDialogState({
                          isOpen: true,
                          index,
                        });
                      }}
                      fontSize="large"
                      color="error"
                      style={{ cursor: "pointer", transform: "rotate(45deg)" }}
                    />
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid item xs={12}>
                    <FormGenerator
                      pIndex={index}
                      children={formInputFields}
                      handleNext={props.handleNext}
                      nextIndex={6}
                      setId={props.setId}
                      style={
                        {
                          // width: "100%",
                        }
                      }
                      moduleName="organization"
                    />
                    <Grid container>
                      <Grid item xs={12} md={4}>
                        Follow up schedule
                      </Grid>
                      <Grid item xs={12} md={8}>
                        {item?.follow_up_schedule?.length
                          ? item?.follow_up_schedule?.map(
                              (childItem, childIndex) => {
                                const formInputFields =
                                  formArray?.length &&
                                  formArray.map((fieldItem) => ({
                                    ...fieldItem,
                                    handleChange: handleChildInputChange,
                                    value: childItem[fieldItem.name],
                                  }));
                                return (
                                  <>
                                    <Grid container>
                                      <Grid item xs={11}>
                                        <FormGenerator
                                          pIndex={`${index}-${childIndex}`}
                                          children={formInputFields}
                                          handleNext={props.handleNext}
                                          nextIndex={6}
                                          setId={props.setId}
                                          style={
                                            {
                                              // width: "100%",
                                            }
                                          }
                                          moduleName="organization"
                                        />
                                      </Grid>
                                      <Grid item xs={1}>
                                        <AddCircleIcon
                                          type="submit"
                                          onClick={() =>
                                            setDialogStateActions({
                                              isOpen: true,
                                              childIndex,
                                              index,
                                            })
                                          }
                                          fontSize="large"
                                          color="error"
                                          style={{
                                            cursor: "pointer",
                                            transform: "rotate(45deg)",
                                          }}
                                        />
                                      </Grid>
                                    </Grid>
                                    <Divider style={{ marginBottom: "20px" }} />
                                  </>
                                );
                              }
                            )
                          : null}
                        <AddCircleIcon
                          type="submit"
                          onClick={() => handleChild(true, 0, index)}
                          fontSize="large"
                          color="primary"
                          style={{ cursor: "pointer" }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </div>
          );
        })}
        <AddCircleIcon
          type="submit"
          onClick={() => handleClientAction(true, 0)}
          fontSize="large"
          color="primary"
          style={{ cursor: "pointer" }}
        />
      </Grid>
      {dialogState?.isOpen && (
        <AlertDialog
          dialogState={dialogState}
          dialogContent={`Are you sure you want to delete this client action list?`}
          handleSubmit={(value) => handleClientAction(false, value?.index)}
          handleClose={() => setDialogState(undefined)}
        />
      )}
      {dialogStateActions?.isOpen && (
        <AlertDialog
          dialogState={dialogStateActions}
          dialogContent={`Are you sure you want to delete this follow up schedule?`}
          handleSubmit={(value) =>
            handleChild(false, value?.childIndex, value?.index)
          }
          handleClose={() => setDialogStateActions(undefined)}
        />
      )}
    </Grid>
  );
};
